/**
 * Auto-generated by Style Dictionary from DTCG tokens.
 * DO NOT EDIT — run `nx run tokens:code` to regenerate.
 *
 * @generated
 */

export const color = {
  semantic: {
    action: {
      contrastText: '#f8f8fa',
      disabledBackground: '#0e0d2414',
      enabled: '#0e0d240a',
      focused: '#484885',
      focusOutline: '#793690',
      hover: '#0e0d2414',
      pressed: '#0e0d2429',
      selected: '#0e0d241f',
      selectedContrast: '#0e0d24',
    },
    background: {
      componentFrame: '#c9c9d1',
      default: '#f8f8fa',
      level1: '#e9e9f0',
      level2: '#fdfdfd',
    },
    border: {
      error: '#ce1c25',
      info: '#0158f9',
      primary: '#793690',
      secondary: '#484885',
      strong: '#17172b',
      subtle: '#0e0d2429',
      success: '#1b7936',
      warning: '#bd4f00',
    },
    button: {
      _neutral: {
        hovered: '#0e0d241f',
        selected: '#0e0d2433',
      },
    },
    'data table': {
      cell: {
        error: '#ce1c250a',
        info: '#0158f90a',
        success: '#1b79360a',
      },
      header: '#e9e9f0',
      row: {
        even: '#e9e9f0',
        groupLevel1: '#afafc952',
        groupLevel2: '#afafc98f',
        odd: '#f8f8fa',
      },
      text: {
        error: '#9d151c',
        info: '#0143bd',
        success: '#155c29',
      },
    },
    error: {
      contrast: '#f8f8fa',
      dark: '#080101',
      hoverSubtle: '#ce1c251a',
      main: '#ce1c25',
      softBg: '#f9e3e4',
      softText: '#42090c',
      subtle: '#fdf6f6',
      text: '#9d151c',
    },
    info: {
      contrast: '#f8f8fa',
      dark: '#00030a',
      hoverSubtle: '#0158f91a',
      main: '#0158f9',
      softBg: '#e0ebfe',
      softText: '#001c50',
      subtle: '#f5f8ff',
      text: '#0143bd',
    },
    link: {
      default: '#0158f9',
      pressed: '#0e0d24',
      visited: '#793690',
    },
    primary: {
      contrast: '#f8f8fa',
      dark: '#050206',
      hoverSubtle: '#7936901a',
      main: '#793690',
      softBg: '#efe7f2',
      softText: '#27112e',
      subtle: '#faf7fb',
      text: '#793690',
    },
    progress: {
      baseBar: '#00000029',
      primary: '#793690',
    },
    scrollbar: {
      thumb: '#7474a2',
      track: '#0e0d2403',
    },
    secondary: {
      contrast: '#f8f8fa',
      dark: '#0e0d24',
      main: '#484885',
      softBg: '#e9e9f0',
      softText: '#17172b',
      subtle: '#f8f8fa',
      text: '#484885',
    },
    skeleton: {
      skeleton: '#00000029',
    },
    success: {
      contrast: '#f8f8fa',
      dark: '#010502',
      hoverSubtle: '#1b79361a',
      main: '#1b7936',
      softBg: '#e3efe7',
      softText: '#092711',
      subtle: '#f6faf7',
      text: '#155c29',
    },
    switch: {
      check: '#1b7936',
      disabled: '#0e0d2414',
    },
    text: {
      contrast: '#f8f8fa',
      disabled: '#00000052',
      primary: '#17172b',
      secondary: '#484885',
    },
    tooltip: {
      background: '#0e0d24',
      text: '#f8f8fa',
    },
    warning: {
      contrast: '#f8f8fa',
      dark: '#070300',
      hoverSubtle: '#bd4f001a',
      main: '#bd4f00',
      softBg: '#f7eae0',
      softText: '#3d1900',
      subtle: '#fcf8f5',
      text: '#903c00',
    },
  },
} as const;

export const colorSemantic = color.semantic;
